"use strict";

var _regeneratorRuntime = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/toConsumableArray");

require("regenerator-runtime/runtime");

var _classCallCheck = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureHookManager = void 0;

var feature_1 = require("../log/feature");

var isPromise = function isPromise(item) {
  return !!item.then;
};
/**
 * {@inheritDoc IFeatureHookManager}
 */


var FeatureHookManager = /*#__PURE__*/function () {
  function FeatureHookManager() {
    _classCallCheck(this, FeatureHookManager);

    this.hookPayloads = [];
    this.registeredCallbacks = [];
    this.registeredMutateHooks = [];
  }
  /** {@inheritDoc IFeatureHookManager.registerHook} */


  _createClass(FeatureHookManager, [{
    key: "registerHook",
    value: function registerHook(name, invokeCallback) {
      (0, feature_1.debug)('register hook %s', name);
      this.registeredCallbacks.push({
        name: name,
        callback: invokeCallback
      });
      var payloads = this.hookPayloads.filter(function (payload) {
        return payload.name === name;
      });

      var _iterator = _createForOfIteratorHelper(payloads),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var payload = _step.value;
          invokeCallback(payload.callingFeature, payload.payload);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /** {@inheritDoc IFeatureHookManager.hook} */

  }, {
    key: "hook",
    value: function hook(feature, name, payload) {
      (0, feature_1.debug)('hook %s, from %s', name, feature.constructor.name);
      this.hookPayloads.push({
        name: name,
        payload: payload,
        callingFeature: feature
      });
      var callback = this.registeredCallbacks.find(function (c) {
        return c.name === name;
      });

      if (callback && callback.callback) {
        callback.callback(feature, payload);
      }
    }
    /** {@inheritDoc IFeatureHookManager.registerMutateHook} */

  }, {
    key: "registerMutateHook",
    value: function registerMutateHook(name, mutateCallback) {
      (0, feature_1.debug)('register mutate hook %s', name);
      this.registeredMutateHooks.push({
        name: name,
        callback: mutateCallback
      });
    }
    /** {@inheritDoc IFeatureHookManager.mutateHook} */

  }, {
    key: "mutateHook",
    value: function mutateHook(name, payload, context, opts) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _ref, _ref$reverse, reverse, result, hooks, _iterator2, _step2, registeredHook;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                (0, feature_1.debug)('calling mutate hook %s', name);
                _ref = opts || {}, _ref$reverse = _ref.reverse, reverse = _ref$reverse === void 0 ? false : _ref$reverse;
                result = payload;
                hooks = this.registeredMutateHooks.filter(function (hook) {
                  return Array.isArray(name) ? name.includes(hook.name) : hook.name === name;
                });

                if (reverse) {
                  (0, feature_1.debug)('reversing hook order...');
                  hooks = _toConsumableArray(hooks).reverse();
                }

                _iterator2 = _createForOfIteratorHelper(hooks);
                _context.prev = 6;

                _iterator2.s();

              case 8:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 15;
                  break;
                }

                registeredHook = _step2.value;
                _context.next = 12;
                return registeredHook.callback(result, context);

              case 12:
                result = _context.sent;

              case 13:
                _context.next = 8;
                break;

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](6);

                _iterator2.e(_context.t0);

              case 20:
                _context.prev = 20;

                _iterator2.f();

                return _context.finish(20);

              case 23:
                return _context.abrupt("return", result);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 17, 20, 23]]);
      }));
    }
    /** {@inheritDoc IFeatureHookManager.mutateHookSync} */

  }, {
    key: "mutateHookSync",
    value: function mutateHookSync(name, payload, context, opts) {
      var _ref2 = opts || {},
          _ref2$reverse = _ref2.reverse,
          reverse = _ref2$reverse === void 0 ? false : _ref2$reverse;

      var result = payload;
      var hooks = this.registeredMutateHooks.filter(function (hook) {
        return Array.isArray(name) ? name.includes(hook.name) : hook.name === name;
      });

      if (reverse) {
        (0, feature_1.debug)('mutate hook (sync): reversing hook order...');
        hooks = _toConsumableArray(hooks).reverse();
      }

      var _iterator3 = _createForOfIteratorHelper(hooks),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var registeredHook = _step3.value;
          var hookResult = registeredHook.callback(result, context);

          if (isPromise(hookResult)) {
            throw new Error('A promise was returned when mutateHookSync() was called');
          }

          result = hookResult;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return result;
    }
  }]);

  return FeatureHookManager;
}();

exports.FeatureHookManager = FeatureHookManager;